export enum Action {
  REPLY,
  REPLYALL,
  FORWARD,
  BACK,
  NEWCONVERSATION,
  VIEWMESSAGE,
  CANCEL_NEWCONVERSATION
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/CLAIMS_PIPELINE/CLMTLK_UI_APP_PIPELINE/src/app/clmtlk/shared/model/action.ts